var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.832 2.5L3.16866 2.5C2.54321 2.5 2.23049 2.5 2.01397 2.64771C1.90672 2.72088 1.8181 2.81758 1.75505 2.93023C1.62775 3.15767 1.65886 3.46494 1.7211 4.07948C1.82497 5.1052 1.87691 5.61807 2.14885 5.98474C2.28436 6.16746 2.45617 6.32099 2.65378 6.43596C3.05032 6.66667 3.57229 6.66667 4.61622 6.66667L15.3844 6.66667C16.4284 6.66667 16.9503 6.66667 17.3469 6.43596C17.5445 6.32099 17.7163 6.16746 17.8518 5.98474C18.1237 5.61807 18.1757 5.1052 18.2796 4.07948C18.3418 3.46494 18.3729 3.15767 18.2456 2.93023C18.1825 2.81758 18.0939 2.72088 17.9867 2.64771C17.7702 2.5 17.4574 2.5 16.832 2.5Z",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66602L2.5 10.8667C2.5 13.9934 2.5 15.5567 3.47631 16.528C4.45262 17.4993 6.02397 17.4993 9.16667 17.4993H10.8333C13.976 17.4993 15.5474 17.4993 16.5237 16.528C17.5 15.5567 17.5 13.9934 17.5 10.8667V6.66602",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 9.16602L11.6663 9.16602",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduct);
export default __webpack_public_path__ + "static/media/icon-product.5fb138593e2d988c11ff01403b826116.svg";
export { ForwardRef as ReactComponent };